import {
  useMemo,
  useState
} from "react";

export default function useSelection(
  rows = []
) {

  const [
    selected,
    setSelected
  ] = useState([]);

  const selectedSet =
    useMemo(
      () => new Set(selected),
      [selected]
    );

  function isSelected(id){

    return selectedSet.has(id);

  }

  function toggle(id){

    setSelected(previous=>{

      if(previous.includes(id)){

        return previous.filter(
          value=>value!==id
        );

      }

      return [

        ...previous,

        id

      ];

    });

  }

  function clear(){

    setSelected([]);

  }

  function toggleAll(){

    if(

      selected.length===rows.length &&

      rows.length>0

    ){

      clear();

      return;

    }

    setSelected(

      rows.map(

        row=>row.id

      )

    );

  }

  const allSelected=

    rows.length>0 &&

    selected.length===rows.length;

  return{

    selected,

    selectedCount:selected.length,

    isSelected,

    toggle,

    toggleAll,

    clear,

    allSelected

  };

}